module.exports = __webpack_public_path__ + "static/img/03.dd4ec01.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/customer/03.png
// module id = +oMl
// module chunks = 1